export const toIsoDateUTC = (d) => {
  if (!d) return '';
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt)) return '';
  const utc = new Date(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate()));
  return utc.toISOString().slice(0, 10);
};

export function makeDefaultRange14() {
  const today = new Date();
  const start = new Date(today);
  start.setDate(today.getDate() - 13);
  const pad = (n) => String(n).padStart(2, '0');
  const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return { start: iso(start), end: iso(today) };
}
